export default "__VITE_ASSET__CV$nceze__"